export default __webpack_public_path__ + "static/media/logo_macread_negativo.8d725ffe.png";